import React from 'react';
import styles from './MetricRow.module.css';

const MetricRow = ({
  columns = 4,
  children,
  className = '',
  style = {}
}) => {
  return (
    <div
      style={{
        gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
        ...style
      }}
      className={`${styles.rowCard} ${className}`.trim()}
    >
      {children}
    </div>
  );
};

export default MetricRow;
